import { Skeleton, Stack } from "@mui/material";
import { useCallback, useState } from "react";

import { WORK_BADGE_PDF_DEFAULT_SETTINGS } from "../constants/badgePdf";
import { useGetWorkBadgePdf } from "../hooks/useGetWorkBadgePdf";
import { WorkBadgePreview } from "./WorkBadgePreview";
import { WorkBadgePreviewError } from "./WorkBadgePreviewError";

interface WorkBadgePreviewContainerProps {
  qualificationName: string;
  workerHeadshotBase64?: string;
}

export function WorkBadgePreviewContainer(props: WorkBadgePreviewContainerProps) {
  const { qualificationName, workerHeadshotBase64 } = props;

  const [badgeContainerWidth, setBadgeContainerWidth] = useState(0);

  // We don't use useRef as on initial render the ref from useRef is not set
  // so we use a callback to set width when the node is actually rendered
  // https://legacy.reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
  const badgeContainerRef = useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      setBadgeContainerWidth(node.getBoundingClientRect().width);
    }
  }, []);

  const { data: workBadgePdf, status: workBadgePdfStatus } = useGetWorkBadgePdf({
    qualificationName,
    workerHeadshotBase64,
  });

  const minHeight = badgeContainerWidth / WORK_BADGE_PDF_DEFAULT_SETTINGS.BADGE.ASPECT_RATIO;

  return (
    <Stack ref={badgeContainerRef} width="100%" alignItems="center">
      {workBadgePdfStatus === "error" && <WorkBadgePreviewError />}

      {workBadgePdfStatus === "loading" && (
        <Skeleton variant="rectangular" height={minHeight} width="100%" />
      )}

      {workBadgePdfStatus === "success" && (
        <WorkBadgePreview workBadgePdf={workBadgePdf} badgeContainerWidth={badgeContainerWidth} />
      )}
    </Stack>
  );
}
